import React, {useContext, useEffect, useRef, useState} from 'react';
import {
    Routes,
    Route
} from "react-router-dom";

import {PAContext} from "./Services/PAContext";

import Home from './Pages/HomePage/Home';
import Features from "./Pages/FeaturesPage/Features";
import Login from "./Pages/LoginPage/Login";
import Dashboard from './components/Restricted/Dashboard/Dashboard';
import CreateEvent from "./components/CreateEventPage/CreateEvent";

import './App.css';

import {Alert, Snackbar, useMediaQuery} from "@mui/material";
import Header from "./Pages/PageHeader/Header";

import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import Planner from "./components/Restricted/Planner/Planner";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import Pricing from "./Pages/PricingPage/Pricing";
import Contact from "./Pages/ContactUsPage/Contact";
import Signup from "./Pages/SignupPage/Signup";
import Admins from "./Pages/Admins/Admins";

import FlightPlanner from './components/Restricted/FlightPlanner/FlightPlanner';
import NanoDashboard from './components/Restricted/GoogleGeminiNano/NanoDashboard';
import ConfirmEmail from "./Pages/PublicAccessUsingLinks/ConfirmEmail";
import NewsletterUnsubscribe from "./Pages/PublicAccessUsingLinks/NewsletterUnsubscribe";
import {PointsProvider} from "./Services/PointsContext";
import ExpenseReviewPage from "./Pages/PublicAccessUsingLinks/ExpenseReviewPage";



// Enable UTC plugin
dayjs.extend(utc);

function App() {

    const isInitialMount = useRef(true);

    const { dataArray, setIsMobileView, setShowSuccessSnackbar } = useContext(PAContext);
    const { Account, authenticated } = dataArray;

    useEffect(() => {
        // 1. Function to update state
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 768);
        };

        // 2. Add the listener
        window.addEventListener('resize', handleResize);

        // 3. Run it once immediately to capture initial size
        handleResize();

        // 4. Cleanup: Remove listener when component unmounts
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const _global_map_ref = useRef();

    const [loginSuccessOpen, setLoginSuccessOpen] = useState(false);
    const handleSnackbarLoginClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setLoginSuccessOpen(false);
    };
    const [logoutSuccessOpen, setLogoutSuccessOpen] = useState(false);
    const handleSnackbarLogoutSuccessClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setLogoutSuccessOpen(false);
    };
    const [logoutFailedOpen, setLogoutFailedOpen] = useState(false);
    const handleSnackbarLogoutFailedClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setLogoutFailedOpen(false);
    };

    const [showSuccessOpen, setShowSuccessOpen] = useState(false);
    const handleSnackbarSuccessClose = (event, reason) => {
        if (reason === 'clickaway') {
//            return;
        }
        setShowSuccessOpen(false);

        setShowSuccessSnackbar(false);
    };

    const [isSearching, setIsSearching] = useState(false);
    const [searchingFor, setSearchingFor] = useState('');

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            authenticated ? setLoginSuccessOpen(true) : setLogoutSuccessOpen(true);
        }
    }, [authenticated]);

    useEffect(() => {
        setShowSuccessOpen(dataArray.showSuccessSnackbar);
    }, [dataArray.showSuccessSnackbar]);

    const theme = createTheme({
        palette: {
            badge: {
                main: '#cbe0f7'
            },
        }
    });

    const [viewingEventGroup, setViewingEventGroup] = useState("current");

    const [showHeader, setShowHeader] = useState(true); // Initially show header
    const isMobile = useMediaQuery('(max-height:500px)');


    useEffect(() => {
        setShowHeader(!isMobile);
    }, [isMobile]);

    const [showConciergeServiceWindow, setShowConciergeServiceWindow] = useState(false);
    useEffect(() => {
        console.log("showConciergeServiceWindow : "+ showConciergeServiceWindow);
    }, [showConciergeServiceWindow]);


    //this is for the Header
    const [selectedMenuItem, setSelectedMenuItem] = useState('');


    const [showAccountDialog, setShowAccountDialog] = useState(false);
    const [showEventsDialog, setShowEventsDialog] = useState(false);
    const [showContactsDialog, setShowContactsDialog] = useState(false);

    return (

        <LocalizationProvider dateAdapter={ AdapterDayjs }>
            <ThemeProvider theme={theme}>
                <PointsProvider Account={Account}>
                    <div className="app">

                        <div className="app-header-holder">
                            <Header
                                showHeader={showHeader}
                                setShowHeader={setShowHeader}

                                selectedMenuItem={selectedMenuItem}
                                setSelectedMenuItem={setSelectedMenuItem}

                                setViewingEventGroup={setViewingEventGroup}
                                showConciergeServiceWindow={showConciergeServiceWindow}
                                setShowConciergeServiceWindow={setShowConciergeServiceWindow}

                                showAccountDialog={showAccountDialog}
                                setShowAccountDialog={setShowAccountDialog}

                            />
                        </div>

                        <div className="app-routes-holder">
                            <Routes>


                                {/* Explicit Page Routes */}
                                <Route path="/Features" element={<Features/>}/>
                                <Route path="/Pricing" element={<Pricing/>}/>
                                <Route path="/ContactUs" element={<Contact/>}/>
                                <Route path="/login" element={<Login/>}/>
                                <Route path="/SignUp" element={<Signup/>}/>
                                <Route path="/createEvent" element={<CreateEvent/>}/>

                                {/* Public Access External Entry Points */}
                                <Route path="/confirmEmailAddress.html" element={<ConfirmEmail/>}/>
                                <Route path="/unsubscribe.html" element={<NewsletterUnsubscribe/>}/>

                                {/* FIX: Move expense-review up here and match with exact or wildcard support */}
                                <Route path="/expense-review/*" element={<ExpenseReviewPage/>}/>

                                {/* Restricted App Section Routes */}
                                <Route path="/Planner/*" element={
                                    <Planner
                                        showHeader={showHeader}
                                        isSearching={isSearching}
                                        searchingFor={searchingFor}
                                        _global_map_ref={_global_map_ref}
                                        showConciergeServiceWindow={showConciergeServiceWindow}
                                        setShowConciergeServiceWindow={setShowConciergeServiceWindow}
                                        showAccountDialog={showAccountDialog}
                                        setShowAccountDialog={setShowAccountDialog}
                                    />
                                }/>

                                <Route path="/FlightPlanner/*" element={
                                    <FlightPlanner
                                        setSelectedMenuItem={setSelectedMenuItem}
                                        isSearching={isSearching}
                                        searchingFor={searchingFor}
                                        _global_map_ref={_global_map_ref}
                                    />
                                }/>

                                <Route path="/NanoDashboard/*" element={<NanoDashboard/>}/>

                                <Route path="/dashboard/*" element={
                                    <Dashboard
                                        viewingEventGroup={viewingEventGroup}
                                        setViewingEventGroup={setViewingEventGroup}/>
                                }/>

                                <Route path="/Admins/*" element={<Admins/>}/>

                                {/* Catch-all fallback Route MUST be last */}
                                <Route path="/" element={
                                    <Home
                                        setIsSearching={setIsSearching}
                                        setSearchingFor={setSearchingFor}
                                    />
                                }/>
                                <Route path="*" element={
                                    <Home
                                        setIsSearching={setIsSearching}
                                        setSearchingFor={setSearchingFor}
                                    />
                                }/>
                            </Routes>
                        </div>

                        <Snackbar
                            open={loginSuccessOpen}
                            autoHideDuration={1000}
                            onClose={handleSnackbarLoginClose}
                            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                        >
                            <Alert onClose={handleSnackbarLoginClose} severity="success" sx={{width: '100%'}}>
                                Success
                            </Alert>
                        </Snackbar>
                        <Snackbar
                            open={logoutSuccessOpen}
                            autoHideDuration={1000}
                            onClose={handleSnackbarLogoutSuccessClose}
                            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                        >
                            <Alert onClose={handleSnackbarLogoutSuccessClose} severity="success" sx={{width: '100%'}}>
                                Success
                            </Alert>
                        </Snackbar>
                        <Snackbar
                            open={logoutFailedOpen}
                            autoHideDuration={1000}
                            onClose={handleSnackbarLogoutFailedClose}
                            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                        >
                            <Alert onClose={handleSnackbarLogoutFailedClose} severity="error" sx={{width: '100%'}}>
                                Failed
                            </Alert>
                        </Snackbar>

                        <Snackbar
                            open={showSuccessOpen}
                            autoHideDuration={1000}
                            onClose={handleSnackbarSuccessClose}
                            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                        >
                            <Alert onClose={handleSnackbarSuccessClose} severity="success" sx={{width: '100%'}}>
                                Success
                            </Alert>
                        </Snackbar>

                    </div>
                </PointsProvider>
            </ThemeProvider>
        </LocalizationProvider>

    )
}

export default App;
